module.exports = __webpack_public_path__ + "img/6U.0f8619e6.png";